const arrData = {
  leftData: [],
  list: [

  ],
  id: 23,
  divisionId: 1,
  divisionName: '大内容事业部',
  targetLevelOne: 2,
  targetLevelOname: '影视会员',
  targetLevelTwo: '2-1',
  targetLevelTname: '影视业务曝光',
  targetValue: 0,
  flag: 0,
  period: '', // 月份
  weekNum: '', // 可能为空  '12, , 34, 45, 56'
  weekNumArr: [],
  targetNodePeriodList: [ // 活动
  ]
}

export default arrData
